import PropTypes from 'prop-types'

import ImageViewer from '../../../ImageViewer/ImageViewer'
import LoaderOverlay from '../../../LoaderOverlay/LoaderOverlay'
import { getAssetLink } from '../../../../helpers/get-asset-link'

import PostSmallCard from './../PostSmallCard/PostSmallCard'

const PostFullCard = ({
  isSubmitting,
  onEditPost,
  onDeletePost,
  onAddComment,
  onLikeDislike,
  onManagePostStatus,
  onDeleteComment,
  handleCancel,
  currentUser,
  post,
  groupName,
  buildingTimezone,
  isCommentsEnabled,
  readOnlyMode = false,
  scrollIntoCommentId,
  onApproveRejectCallback,
}) => {
  return (
    <div className="post-full-card">
      <div className={`post-full-card__container`}>
        {post && !post.isWelcomePost && post.images.length > 0 && (
          <div className="left-side">
            <ImageViewer
              images={post.images}
              getImagesMethod={(image) =>
                getAssetLink({ path: 'chitown-images/groups', file: image })
              }
            />
          </div>
        )}
        {post && (
          <div className="right-side">
            <PostSmallCard
              post={post}
              onDeletePost={onDeletePost}
              onEditPost={onEditPost}
              onAddComment={onAddComment}
              onManagePostStatus={onManagePostStatus}
              onDeleteComment={onDeleteComment}
              onLikeDislike={onLikeDislike}
              handleClose={handleCancel}
              currentUser={currentUser}
              groupName={groupName}
              isExpandedPost
              buildingTimezone={buildingTimezone}
              isCommentsEnabled={isCommentsEnabled}
              readOnlyMode={readOnlyMode}
              scrollIntoCommentId={scrollIntoCommentId}
              onApproveRejectCallback={onApproveRejectCallback}
              isSubmitting={isSubmitting}
            />
          </div>
        )}
      </div>
      {isSubmitting && <LoaderOverlay />}
    </div>
  )
}

PostFullCard.propTypes = {
  isSubmitting: PropTypes.bool,
  onDeletePost: PropTypes.func,
  onEditPost: PropTypes.func,
  onAddComment: PropTypes.func,
  onLikeDislike: PropTypes.func,
  onManagePostStatus: PropTypes.func,
  onDeleteComment: PropTypes.func,
  handleCancel: PropTypes.func,
  currentUser: PropTypes.object,
  post: PropTypes.object,
  groupName: PropTypes.string,
  buildingTimezone: PropTypes.string,
  isCommentsEnabled: PropTypes.bool,
  readOnlyMode: PropTypes.bool,
  scrollIntoCommentId: PropTypes.number,
}

export default PostFullCard
